import PoA from './PoA'

export default PoA
